import { types, actions } from './requests'
export const DELETEITEM_TYPES = {
    ...types('DELETEITEM'),
}
export const DELETEITEM_ACTIONS = {
    ...actions('DELETEITEM'),
}
